import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory } from 'react-router';
import { useOverlayContext, ConfirmationModal } from 'seagull';
import { ErrorText, routes } from '~/constants';
import { useStoreActions } from '~/contexts';
import { useDraftProposal } from '~/hooks/reactQuery/mutations/useDraftProposal';
import { useDuplicateRelationship } from '~/hooks/useDuplicateRelationship';
import { ErrorResponse, ServerError } from '~/infra/ErrorResponse';
export function useWithdrawToEditProposal() {
    const overlayContext = useOverlayContext();
    const { duplicateRelationship } = useDuplicateRelationship();
    const { api } = useStoreActions();
    const history = useHistory();
    const { draftProposal } = useDraftProposal({
        onSuccess: (newDraftId)=>history.push(routes.draft(newDraftId))
    });
    async function approveWithdrawProposal(action, errorMessage, modalProps) {
        const confirmed = await overlayContext.showModal({
            closeOnClickOutside: true,
            shouldBlurBackground: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, _object_spread_props(_object_spread({
                    skin: "danger"
                }, modalProps), {
                    onPrimaryButtonClick: ()=>dismissModal(true),
                    onSecondaryButtonClick: ()=>dismissModal(false)
                }));
            }
        });
        if (confirmed) {
            try {
                await action();
            } catch (err) {
                overlayContext.showErrorToast(errorMessage);
            }
        }
    }
    async function cancelProposal(id) {
        try {
            await api.relationship.cancelProposal(id);
        } catch (err) {
            if (new ErrorResponse(err).hasServerError(ServerError.InvalidRelationshipStatus)) {
                overlayContext.showErrorToast(ErrorText.ProposalAlreadyAcceptedOrCanceled);
            } else {
                overlayContext.showErrorToast(ErrorText.UnexpectedErrorTryAgain, 'cancel-proposal-error');
            }
            throw err;
        }
    }
    async function withdrawToEditAndRedirect(id, draftId) {
        return draftProposal({
            relationshipId: id,
            draftId
        });
    }
    return {
        withdrawToEditProposalByIdWithConfirmation: async (id, draftId)=>{
            return approveWithdrawProposal(()=>withdrawToEditAndRedirect(id, draftId), 'Failed to withdraw proposal for editing', {
                title: 'Withdraw to edit',
                content: 'Once you withdraw this proposal, the client’s previous link will be disabled. As soon as you send the new proposal, an email will be sent with a link to the new version.',
                primaryButtonLabel: 'Withdraw and edit',
                secondaryButtonLabel: 'Cancel'
            });
        },
        withdrawToEditProposalById: async function withdrawToEditProposalById(id) {
            let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            const draftId = await duplicateRelationship(id, {
                strategy: 'withdraw-to-edit',
                onError: opts.onDuplicateRelationshipError
            });
            await cancelProposal(id);
            return draftId;
        }
    };
}
